function CameraIcon()
{
    return(
        <svg fill="#fcfcfcff" width="60%" height="60%" viewBox="0 0 198.931 198.931">
<g>
	<g>
		<g>
			<path d="M99.469,69.561c-25.423,0-46.104,20.683-46.104,46.104s20.683,46.104,46.104,46.104     c25.421,0,46.104-20.683,46.104-46.104S124.89,69.561,99.469,69.561z M99.469,146.91c-17.229,0-31.245-14.017-31.245-31.245     c0-17.228,14.017-31.245,31.245-31.245c17.228,0,31.245,14.017,31.245,31.245C130.714,132.892,116.698,146.91,99.469,146.91z"/>
			<path d="M175.499,44.681h-72.315h-3.715V27.956c0-9.393-7.64-17.036-17.033-17.036H44.247c-9.393,0-17.033,7.642-17.033,17.036     v16.726h-3.777C10.515,44.681,0,55.194,0,68.116v96.465c0,12.92,10.515,23.43,23.437,23.43h152.059     c12.925,0,23.435-10.51,23.435-23.43V68.116C198.934,55.194,188.421,44.681,175.499,44.681z M42.07,27.956     c0-1.201,0.976-2.176,2.177-2.176h38.189c1.199,0,2.174,0.976,2.174,2.177v16.726H42.07V27.956z M175.499,173.152H23.437     c-4.73,0-8.578-3.846-8.578-8.571V68.116c0-4.73,3.848-8.576,8.578-8.576h5.451H42.07h42.538h18.573h72.315     c4.73,0,8.576,3.846,8.576,8.576v96.465h0.003C184.075,169.306,180.229,173.152,175.499,173.152z"/>
			<rect x="156.012" y="71.816" width="18.989" height="14.859"/>
		</g>
	</g>
</g>
</svg>
    )
}

export default CameraIcon